import Vue from "vue";
import VueRouter from "vue-router";


Vue.use(VueRouter);

const routes = [
  {
    path: '/ShenZhenDianXinManTuo',
    name: 'ShenZhenDianXinManTuo',
    components: {
      default: () =>
        import("@/pages/ShenZhendianXinManTuo.vue")
    },
    meta: {
      title: '深圳电信'
    }
  },
  {
    path: '/GuangZhouDianXinManTuo',
    name: 'GuangZhouDianXinManTuo',
    components: {
      default: () =>
        import("@/pages/GuangZhouDianXinManTuo.vue")
    },
    meta: {
      title: '广州电信'
    }
  },
  {
    path: "/GuangzhouDianxinOrderCheck",
    name: "GuangzhouDianxinOrderCheck",
    components: {
      default: () =>
        import("@/pages/GuangzhouDianxinOrderCheck"),
    },
    meta: {
      title: "广州电信骑士卡查询",
    },
  }, {
    path: "/ShenZhenDianXinSelect",
    name: "ShenZhenDianXinSelect",
    components: {
      default: () =>
        import("@/pages/ShenZhenDianXinSelect"),
    },
    meta: {
      title: "深圳电信骑士卡查询",
    },
  },
  {
    path: "/unicomDeal9",
    name: "unicomDeal9",
    components: {
      default: () =>
        import("@/pages/deal/unicomDeal9"),
    },
    meta: {
      title: "中国联通骑士卡相关协议",
    },
  },
  {
    path: "/unicomDeal7hunan",
    name: "unicomDeal7hunan",
    components: {
      default: () =>
        import("@/pages/deal/unicomDeal7hunan"),
    },
    meta: {
      title: "中国联通骑士卡相关协议",
    },
  },
  {
    path: '/GuangZhouLianTongManTuo',
    name: 'GuangZhouLianTongManTuo',
    components: {
      default: () =>
        import("@/pages/GuangZhouLianTongManTuo.vue")
    },
    meta: {
      title: '广州联通'
    }
  }, {
    path: '/GuangZhouLianTong',
    name: 'GuangZhouLianTong',
    components: {
      default: () =>
        import("@/pages/GuangZhouLianTong.vue")
    },
    meta: {
      title: '深圳联通'
    }
  },{
    path: '/handing',
    name: 'handing',
    components: {
      default: () =>
        import("@/pages/handing.vue")
    },
    meta: {
      title: '订单'
    }
  },
  {
    path: '/HuNanLianTongManTuo',
    name: 'HuNanLianTongManTuo',
    components: {
      default: () =>
        import("@/pages/HuNanLianTongManTuo.vue")
    },
    meta: {
      title: '湖南联通语音卡- SR'
    }
  },
  {
    path: '/ZhongGuoLianTongManTuo',
    name: 'ZhongGuoLianTongManTuo',
    components: {
      default: () =>
        import("@/pages/ZhongGuoLianTongManTuo.vue")
    },
    meta: {
      title: '中国联通'
    }
  },
  {
    path: '/JiangShuLianTongManTuo',
    name: 'JiangShuLianTongManTuo',
    components: {
      default: () =>
        import("@/pages/JiangShuLianTongManTuo.vue")
    },
    meta: {
      title: '江苏联通语音卡- SR'
    }
  },
  {
    path: "/notData",
    name: "notData",
    components: {
      default: () =>
        import("@/pages/notData"),
    },
    meta: {
      title: "错误",
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
